var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15H2a2 2 0 01-2-2V2a2 2 0 012-2h11a2 2 0 012 2v2.5H5.5a1 1 0 00-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5v-8C3 4.12 4.121 3 5.5 3h8V2a.5.5 0 00-.5-.5H2a.5.5 0 00-.5.5v11a.5.5 0 00.5.5zM4.5 15H1.999C.898 15 0 14.103 0 13V2C0 .897.897 0 2 0h11c1.103 0 2 .897 2 2v2.5H5.5c-.551 0-1 .449-1 1V15z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    rx: 2,
    width: 15,
    x: 3,
    y: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13.5,
    rx: 1.25,
    width: 13.5,
    x: 3.75,
    y: 3.75
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(1531 -1725)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1.5,
    rx: 0.75,
    width: 8,
    x: -1524.5,
    y: 1734.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.5,
    rx: 0.75,
    transform: "rotate(90 -1625.625 105.875)",
    width: 8
  }))));
}
export default __webpack_public_path__ + "media/icons/icn_filter-f7db10a1.svg";
export { SvgIcnFilter as ReactComponent };